var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25016 0.916626H12.7502C13.7627 0.916626 14.5835 1.73744 14.5835 2.74996V3.66663H17.3335C18.346 3.66663 19.1668 4.48744 19.1668 5.49996V7.33329C19.1668 8.34581 18.346 9.16663 17.3335 9.16663H17.26L16.4168 19.25C16.4168 20.2625 15.596 21.0833 14.5835 21.0833H5.41683C4.40431 21.0833 3.5835 20.2625 3.58666 19.3261L2.74004 9.16663H2.66683C1.65431 9.16663 0.833496 8.34581 0.833496 7.33329V5.49996C0.833496 4.48744 1.65431 3.66663 2.66683 3.66663H5.41683V2.74996C5.41683 1.73744 6.23764 0.916626 7.25016 0.916626ZM2.66683 5.49996H5.41683H14.5835H17.3335V7.33329H2.66683V5.49996ZM4.57944 9.16663H15.4206L14.5867 19.1738L14.5835 19.25H5.41683L4.57944 9.16663ZM12.7502 2.74996V3.66663H7.25016V2.74996H12.7502Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.4f7bb28b.svg";
export { ForwardRef as ReactComponent };